import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=5bec40e1&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"
import style0 from "./cancel.vue?vue&type=style&index=0&id=5bec40e1&prod&lang=scss&scoped=true&"
import style1 from "./cancel.vue?vue&type=style&index=1&id=5bec40e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec40e1",
  null
  
)

export default component.exports